import { maxWidth } from '@/assets/styles/mixins.css.js'
import styled from 'styled-components'
import vars from '@/assets/styles/vars'
import Title from './StyledTitle'

const maxLeftColumnDesktopWidth = '360px'

const MainFeatures = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 40%) minmax(0, 60%);
  grid-gap: 32px;

  ${Title} {
    max-width: ${maxLeftColumnDesktopWidth};
  }

  ${maxWidth(vars.breakpoints.tablet)`
    grid-template-columns: minmax(0, 1fr);
    grid-gap: 40px;

    ${Title} {
      max-width: none;
      margin-bottom: 16px;
    }
  `}

  ${maxWidth(vars.breakpoints.lMobile)`
    grid-gap: 32px;
  `}
`

MainFeatures.Desc = styled.p`
  max-width: ${maxLeftColumnDesktopWidth};
  margin-bottom: 32px;
  font-size: 16px;
  line-height: 1.6;
  color: var(--color-secondary);

  ${maxWidth(vars.breakpoints.tablet)`
    max-width: none;
    margin-bottom: 16px;
    font-size: 14px;
  `}
`

MainFeatures.VideoLink = styled.div`
  max-width: ${maxLeftColumnDesktopWidth};
  --vlink-icon-width: 64px;
  --vlink-icon-bg: #fff;

  ${maxWidth(vars.breakpoints.tablet)`
    max-width: none;
    --vlink-font-size: 14px;
    --vlink-icon-width: 56px;
    --vlink-icon-space: 16px;
  `}
`

MainFeatures.List = styled.ul`
  --feature-icon-bg: #fff;
  --feature-icon-shadow-opacity: 1;

  display: grid;
  grid-template-columns: minmax(0, 320px) minmax(0, 320px);
  grid-gap: 32px 70px;

  ${maxWidth(vars.breakpoints.tablet)`
    --feature-icon-bg: var(--color-bg-accent);
    --feature-icon-shadow-opacity: 0;

    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    grid-gap: 20px;
  `}

  ${maxWidth(vars.breakpoints.lMobile)`
    grid-template-columns: minmax(0, 1fr);
    grid-gap: 12px;
  `}
`

export default MainFeatures
